import { TASK_PAGE,GRN_LIST, PURCHASE_ORDER_LIST, ATTENDANCE, ATTENDANCE_ACTION, BASE, PROFILE, SITE, DRIVE, LIST_BILLS, USER_PAGE, LEAVE_CALENDAR, LEAVE_REQUEST_LIST, LEAVE_APPROVALS, ESS, LEAVE_SUMMARY_LIST, SALARY_MASTER, SALARY_SLIP, LEAVE_CREDIT_DEBIT_LIST, EMP_REFERRAL_LIST, TRAINING, ZOHO_TAG_LIST } from "../routes";
import { USER_ROLES } from "./Strings";
//Note: In order to allow submenu to particular role then that role should be present in the parent route's role array.

export const MENU_ITEMS = [
  {
    name: "Dashboard",
    route: BASE,
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
  },
  {
    name: "Drive",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
    SUB_MENU: [
      {
        name: "My Drive",
        route: DRIVE.replace(":type", "my"),
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Shared Drive",
        route: DRIVE.replace(":type", "shared"),
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
    ],
  },
  {
    name: "Profile",
    route: PROFILE,
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
  },
  {
    name: "Training",
    route: TRAINING,
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
  },
  {
    name: "ESS",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
    SUB_MENU: [
      {
        name: "Employee Documents",
        route: ESS,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Employee Referrals",
        route: EMP_REFERRAL_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
    ],
  },
  {
    name: "Manage",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
    SUB_MENU: [
      {
        name: "Attendance View",
        route: ATTENDANCE,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Attendance Action",
        route: ATTENDANCE_ACTION,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Bills",
        route: LIST_BILLS,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Task",
        route: TASK_PAGE,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Site",
        route: SITE,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      { name: "Reporting Tags", route: ZOHO_TAG_LIST, roles: [USER_ROLES.ADMIN, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS] },
      { name: "Users", route: USER_PAGE, roles: [USER_ROLES.ADMIN, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS] },
    ],
  },
  {
    name: "Leave Management",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
    SUB_MENU: [
      {
        name: "Yearly Calendar",
        route: LEAVE_CALENDAR,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Leave Requests",
        route: LEAVE_REQUEST_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Leave Actions",
        route: LEAVE_APPROVALS,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Leave Summary",
        route: LEAVE_SUMMARY_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS]
},
      {
        name: "Leave Credit/Debit",
        route: LEAVE_CREDIT_DEBIT_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS]
}
    ],
  },
  {
    name: "Payroll",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
    SUB_MENU: [
      {
        name: "Salary Master",
        route: SALARY_MASTER,
        roles: [USER_ROLES.ADMIN, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
      {
        name: "Salary Slip",
        route: SALARY_SLIP,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT, USER_ROLES.ACCOUNTS],
      },
    ],
    
  },
  {
    name: "Procurement",
    roles: [
      USER_ROLES.ADMIN,
      USER_ROLES.PROJECT_INCHARGE,
      USER_ROLES.INCHARGE,
      USER_ROLES.SITE_STAFF,
      USER_ROLES.HR,
      USER_ROLES.DIRECTOR_MANAGEMENT,
      USER_ROLES.ACCOUNTS,
    ],
    SUB_MENU: [
      {
        name: "Purchase Order",
        route: PURCHASE_ORDER_LIST,
        roles: [
          USER_ROLES.ADMIN,
          USER_ROLES.PROJECT_INCHARGE,
          USER_ROLES.INCHARGE,
          USER_ROLES.SITE_STAFF,
          USER_ROLES.HR,
          USER_ROLES.DIRECTOR_MANAGEMENT,
          USER_ROLES.ACCOUNTS,
        ],
      },
      {
        name: "GRN",
        route: GRN_LIST,
        roles: [
          USER_ROLES.ADMIN,
          USER_ROLES.PROJECT_INCHARGE,
          USER_ROLES.INCHARGE,
          USER_ROLES.SITE_STAFF,
          USER_ROLES.HR,
          USER_ROLES.DIRECTOR_MANAGEMENT,
          USER_ROLES.ACCOUNTS,
        ],
      },
    ],
  },
];